<template>
  <UModal
    :title
    :description
    dismissible
    :icon
    :ui="{ header: 'pb-2', description: 'mt-2' }"
  >
    <template
      v-if="body"
      #body
    >
      <UEditor
        :model-value="body"
        :editable="false"
      />
    </template>
    <template #footer="{ close }">
      <UButton
        color="primary"
        class="cursor-pointer rounded-full"
        @click="emit('close', true)"
      >
        Confirmar
      </UButton>
      <UButton
        color="neutral"
        variant="outline"
        class="cursor-pointer rounded-full"
        @click="close"
      >
        Cancelar
      </UButton>
    </template>
  </UModal>
</template>

<script setup lang="ts">
const emit = defineEmits<{ close: [value: boolean] }>()
const system = useSystemStore()
const modalId = system.getModal()

onMounted(() => {
  system.pushModal(modalId)
})

onBeforeUnmount(() => {
  system.popModal(modalId)
})

defineProps({
  title: {
    type: String,
    required: true
  },
  description: {
    type: String,
    required: true
  },
  icon: {
    type: String,
    required: false
  },
  body: {
    type: String,
    required: false
  }
})

defineShortcuts({
  escape: () => {
    if (!system.isTopModal(modalId))
      return
    emit('close', false)
  },
  enter: () => {
    if (!system.isTopModal(modalId))
      return
    emit('close', true)
  }
})
</script>
